import React, { useEffect } from 'react';
import './CanhBaoPage.css';

function CanhBaoPage() {
  useEffect(() => {
    const lockBackNavigation = () => {
      window.history.pushState(null, '', window.location.href);
    };

    lockBackNavigation();
    window.addEventListener('popstate', lockBackNavigation);

    return () => {
      window.removeEventListener('popstate', lockBackNavigation);
    };
  }, []);

  return (
    <div className="canh-bao-page">
      <div className="canh-bao-card">
        <h1>Cảnh báo bảo mật</h1>
        <p>Hệ thống phát hiện bạn đang mở công cụ phát triển (F12).</p>
        <p>Phiên làm việc đã được đăng xuất và tạm khóa truy cập chấm công trên trình duyệt này.</p>
        <p>Vui lòng đóng tab này và sử dụng điện thoại để tiếp tục chấm công.</p>
      </div>
    </div>
  );
}

export default CanhBaoPage;
